// extracted by mini-css-extract-plugin
export default {"theme":"r0v8R","theme_theme_light":"JEcdN","theme_theme_dark":"rNCZ1"};